import React from "react";

/**
 * Cohnect wordmark lockup rendered from the final brand images.
 * `tone` picks the correct variant for the background it sits on:
 *   - "ink"  (default) -> dark logo, for LIGHT backgrounds (e.g. admin, light theme)
 *   - "light"          -> white logo, for DARK backgrounds (dark theme)
 * `height` (or legacy `iconSize`) controls the rendered logo height in px.
 */
const LIGHT_BG_LOGO = "/brand/horizontal-logo-light.webp"; // black logo
const DARK_BG_LOGO = "/brand/horizontal-logo-dark.webp"; // white logo

export const CohnectLogo = ({ className = "", tone = "ink", height, iconSize }) => {
  const h = height || iconSize || 26;
  const src = tone === "light" ? DARK_BG_LOGO : LIGHT_BG_LOGO;
  return (
    <img
      src={src}
      alt="Cohnect"
      draggable="false"
      style={{ height: `${h}px`, width: "auto" }}
      className={`block select-none ${className}`}
    />
  );
};
